import MiLayout from './MiLayout.vue'

export default MiLayout
